import React, { useState, useEffect } from 'react'
import { useParams, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux'
import { cleanFormProjeto, listarMeusProjetos, listarSubsegmentos, setFormProjetoLista } from '../redux/meusProjetosActions'
import { Button, IcoHelpCircle, IcoSearch, Input, Popover, Select } from '../../../components'
import { IF, history } from '../../../helpers';
import Projeto from './projeto/projeto';
import Empresas from './empresas/empresas';
import Estabelecimentos from './estabelecimentos/estabelecimentos';
import Produtos from './produtos/produtos';
import Video from '../../videos/video'


export default () => {
  const dispatch = useDispatch()
  const { idProjetos, idPasso } = useParams()
  const location = useLocation();
  const { sistema } = useSelector(state => state.layoutState)
  const nls = require(`../nls/${sistema.idioma}.json`)

  const { listMeusProjetos, paginate, meuProjeto } = useSelector(state => state.meusProjetosState)
  const [form, setForm] = useState({ projeto: {}, search: '' })
  const projetosPermitidos = listMeusProjetos.filter(e => e.permissaoEditarProjeto && e.situacao !== 'I')
  const selectedProjectHas = projetosPermitidos.find(e => String(e.idProjeto) === String(idProjetos))

  const routeMap = {
    projeto: 'project',
    empresas: 'companies',
    estabelecimentos: 'stores',
    produtos: 'products',
  }

  const reverseRouteMap = Object.fromEntries(
    Object.entries(routeMap).map(([k, v]) => [v, k])
  )

  const internalStep = reverseRouteMap[idPasso] || idPasso

  useEffect(() => {
    if (!idPasso) {
      history.push(`/myprojects/${idProjetos}/configure/${routeMap[listTab[0].id]}`)
    }
    setForm({ ...form, search: '' })
  }, [idPasso])

  useEffect(() => {
    dispatch(cleanFormProjeto())
  }, [])


  //AJUSTADO PARA MOSTRAR A PÁGINA DE CONFIGURAÇÃO DE COMPANIES
  useEffect(() => {
    if (!selectedProjectHas?.idProjeto && projetosPermitidos.length && 
      internalStep !== 'empresas') {
      history.push(`/myprojects/${projetosPermitidos[0].idProjeto}/configure/${routeMap[listTab[0].id]}`)
    }
  }, [selectedProjectHas, projetosPermitidos])


  useEffect(() => {
    setForm({ ...form, projeto: selectedProjectHas ? selectedProjectHas : {} })
    dispatch(setFormProjetoLista({ name: 'projeto', value: selectedProjectHas ? selectedProjectHas : {} }))
  }, [selectedProjectHas])

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const searchTerm = query.get(idPasso);
    if (searchTerm) {
      setForm({ ...form, search: searchTerm })
    }
  }, [history.location])

  const listTab = [
    {
      id: 'projeto',
    },
    ...meuProjeto.projeto.temMenuEmpresa ? [{
      id: 'empresas',
    }] : [],
    ...meuProjeto.projeto.temMenuEstabelecimento ? [{
      id: 'estabelecimentos',
    }] : [],
    ...meuProjeto.projeto.temMenuProduto ? [{
      id: 'produtos',
    }] : [],
  ]

  const handleSearch = (e, t) => {
    let val = ''
    if (e) {
      val = `?${t}=${e}`
    }
    history.push({
      search: val
    });
  }

  const contentPage = e => {
    switch (e) {
      case 'projeto':
        return <Projeto />;
      case 'empresas':
        return <Empresas />;
      case 'estabelecimentos':
        return <Estabelecimentos />;
      case 'produtos':
        return <Produtos />;
      default:
        return <div></div>;
    }
  }

  // ✅ mapeia a aba atual para o vídeo correspondente
  const videoMap = {
    projeto: 'video10',           // Tipos de projetos (ajuste se preferir video10)
    empresas: 'video11',         // Configurar empresas
    estabelecimentos: 'video12', // Configurar Estabelecimentos
    produtos: 'video13',         // Configurar Produtos
  }
  const currentVideoName = videoMap[internalStep] || 'video9'

  
  return (
    <div className='box-meus-projetos-configurar'>
      <div className='box-content'>
        <div className='box-content-topinfo'>
           {/* ✅ título + botão de vídeo lado a lado */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
            <h3 style={{ margin: 0 }}>{nls.configurar.title}</h3>
            <Video videoName={currentVideoName} />
          </div>
          <div className='actions-tab'>
            {
              listTab.map(e => (
                <Button
                  key={e.id}
                  color={internalStep === String(e.id) ? 'primary' : 'default'}
                  variant='underline'
                  onClick={() => history.push(`/myprojects/${idProjetos}/configure/${routeMap[e.id]}`)}
                >
                  {nls.configurar[e.id]}
                </Button>
              ))
            }
          </div>
        </div>
        <div className='box-meus-projetos-configurar-search'>
          <Select
            name='projeto'
            label=''
            options={projetosPermitidos}
            selected={form.projeto}
            action={(e) => history.push(`/myprojects/${e.value.idProjeto}/configure/${routeMap[listTab[0].id]}`)}
            selectedItem={false}
            textCustom={nls.select}
            optionLabel='descricao'
            optionValue='idProjeto'
          />
          <IF se={internalStep !== 'projeto'}>
            <Input
              name='search'
              label=''
              value={form.search}
              placeholder={nls.configurar?.[`SPH${internalStep}`]}
              action={(e) => setForm({ ...form, [e.name]: e.value })}
              left={<Button
                type='link'
                color='default'
                onClick={() => handleSearch(form.search, internalStep)}
              ><IcoSearch /></Button>}
            />
          </IF>
        </div>
        {
          idProjetos ? <div>
            {contentPage(internalStep)}
          </div> : null
        }
      </div>
    </div>
  )
}
